import { lazyWithReload } from 'utils/lazyWithReload';

const LazyAddShiftErrorAlert = lazyWithReload(
  () => import('./AddShiftErrorAlert'),
  'AddShiftErrorAlert'
);
const LazyDeleteShiftErrorAlert = lazyWithReload(
  () => import('./DeleteShiftErrorAlert'),
  'DeleteShiftErrorAlert'
);
const LazyAddShiftModal = lazyWithReload(
  () => import('./AddShiftModal'),
  'AddShiftModal'
);
const LazyDeleteShiftModal = lazyWithReload(
  () => import('./DeleteShiftModal'),
  'DeleteShiftModal'
);
const LazyDeleteReasonModal = lazyWithReload(
  () => import('./DeleteReasonModal'),
  'DeleteReasonModal'
);
const LazyDeleteReasonSuccessToast = lazyWithReload(
  () => import('./DeleteReasonSuccessToast'),
  'DeleteReasonSuccessToast'
);
const LazyDeleteReasonErrorAlert = lazyWithReload(
  () => import('./DeleteReasonErrorAlert'),
  'DeleteReasonErrorAlert'
);
const LazyAddShiftSuccessToast = lazyWithReload(
  () => import('./AddShiftSuccessToast'),
  'AddShiftSuccessToast'
);
const LazyAddReasonSuccessToast = lazyWithReload(
  () => import('./AddReasonSuccessToast'),
  'AddReasonSuccessToast'
);
const LazyAddReasonErrorAlert = lazyWithReload(
  () => import('./AddReasonErrorAlert'),
  'AddReasonErrorAlert'
);
const LazyLogoutModal = lazyWithReload(
  () => import('./LogoutModal'),
  'LogoutModal'
);
const LazyCloseWeekModal = lazyWithReload(
  () => import('./CloseWeekModal'),
  'CloseWeekModal'
);
const LazyCloseWeekSuccessToast = lazyWithReload(
  () => import('./CloseWeekSuccessToast'),
  'CloseWeekSuccessToast'
);
const LazyCloseWeekErrorAlert = lazyWithReload(
  () => import('./CloseWeekErrorAlert'),
  'CloseWeekErrorAlert'
);
const LazyDeleteShiftSuccessToast = lazyWithReload(
  () => import('./DeleteShiftSuccessToast'),
  'DeleteShiftSuccessToast'
);
const LazyCopyTextSuccessToast = lazyWithReload(
  () => import('./CopyTextSuccessToast'),
  'CopyTextSuccessToast'
);
const LazyAddReasonModal = lazyWithReload(
  () => import('./AddReasonModal'),
  'AddReasonModal'
);

export {
  LazyAddReasonErrorAlert,
  LazyAddReasonModal,
  LazyAddReasonSuccessToast,
  LazyAddShiftErrorAlert,
  LazyAddShiftModal,
  LazyAddShiftSuccessToast,
  LazyCloseWeekErrorAlert,
  LazyCloseWeekModal,
  LazyCloseWeekSuccessToast,
  LazyCopyTextSuccessToast,
  LazyDeleteReasonErrorAlert,
  LazyDeleteReasonModal,
  LazyDeleteReasonSuccessToast,
  LazyDeleteShiftErrorAlert,
  LazyDeleteShiftModal,
  LazyDeleteShiftSuccessToast,
  LazyLogoutModal
};
